<!-- <app-festival-decoration></app-festival-decoration> -->

@if (shouldHideLogin) {
  <div class="login-exit-overlay" aria-busy="true" aria-live="polite" aria-label="Signing in">
    <div class="login-exit-loader">
      <img src="assets/images/login/workluge-logo.png" class="login-exit-logo" alt="WorkLuge Logo" />
      <app-spinner [size]="32"></app-spinner>
    </div>
  </div>
}

@if (!shouldHideLogin) {
<app-festival-decoration></app-festival-decoration>
<div class="login_page" [class.fall-of-summer]="fallOfSummer" [class.thanksgiving]="thanksgiving" [class.halloween]="halloween" [class.remembrance]="remembrance" [class.festival-active]="hideLoginIllustrations">
  @if (!hideLoginIllustrations) {
  <div class="illustration left" [class]="'entry-' + entryPoint">
    <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
    <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
    <img src="assets/images/login/road.png" alt="Road Illustration" />
  </div>
  }

  <div class="login_card">
    <div class="logo_wrap">
      <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
      @if (remembrance) {
      <img src="assets/images/events/rem-poppy.png" class="remembrance-poppy" alt="" draggable="false" />
      <div class="logo-poppy-bees" aria-hidden="true">
        <img src="assets/images/events/honeybee.gif" class="logo-poppy-bee" alt="" draggable="false" />
      </div>
      <div class="logo-poppy-fall" aria-hidden="true">
        @for (petal of loginPoppies; track $index) {
        <span
          class="logo-poppy"
          [style.--leaf-left]="petal.left"
          [style.--leaf-size]="petal.size"
          [style.--leaf-duration]="petal.duration"
          [style.--leaf-delay]="petal.delay"
          [style.--leaf-drift]="petal.drift"
          [style.--leaf-spin]="petal.spin"
          [style.background-image]="'url(' + petal.src + ')'"
        ></span>
        }
      </div>
      }
      @if (halloween && halloweenDecorReady()) {
      <div class="logo-halloween-ybats" aria-hidden="true">
        <img
          src="assets/images/events/halloween-ybat.gif"
          class="logo-halloween-ybat bat-a"
          alt=""
          draggable="false"
          loading="lazy"
          decoding="async"
        />
        <img
          src="assets/images/events/halloween-ybat.gif"
          class="logo-halloween-ybat bat-b"
          alt=""
          draggable="false"
          loading="lazy"
          decoding="async"
        />
        <img
          src="assets/images/events/halloween-ybat.gif"
          class="logo-halloween-ybat bat-c"
          alt=""
          draggable="false"
          loading="lazy"
          decoding="async"
        />
      </div>
      }
    </div>
    <div class="quote">
      <img src="assets/images/login/smiley.png" class="smiley" alt="Smiley" />
      <span class="quote-text">
        {{ currentQuote }}
      </span>
    </div>

    @if (!showAgencySelection) {
    <form [formGroup]="loginForm" (ngSubmit)="onFormSubmit($event)">
      <div class="input_group">
        <div class="validation_slot" aria-live="polite">
          @if (email?.invalid && (isEmailTyping || email?.touched) && !email?.errors?.['backendError']) {
          <div class="validation_error">
            {{ getErrorMessage('email') }}
          </div>
          }
        </div>
        <div class="form-fields input-with-success">
          <input type="text" id="email" formControlName="email" placeholder="Enter Email"
            [class.is-invalid]="(email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']"
            [class.is-valid]="email?.valid && email?.touched" (focus)="onEmailFocus()" (input)="onEmailInput()"
            (keyup)="onEmailKeyup($event)" appPreventLeadingSpace />
          @if (email?.valid && email?.touched) {
          <span class="success-circle"></span>
          }
          @if ((email?.invalid && (isEmailTyping || email?.touched)) || email?.errors?.['backendError']) {
          <span class="error-circle"></span>
          }
        </div>
      </div>

      <div class="input_group mt-3">
        <div class="validation_slot" aria-live="polite">
          @if (passcode?.invalid && (isPasswordTyping || passcode?.touched) && !passcode?.errors?.['backendError']) {
          <div class="validation_error nw_pss_err">
            {{ getErrorMessage('passcode') }}
          </div>
          }
        </div>
        <div class="passcode_wrapper">
          <input [type]="showPassword ? 'text' : 'password'" formControlName="passcode" placeholder="Password"
            (input)="onPasswordInput()"
            [class.is-invalid]="(passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] || email?.errors?.['backendError']"
            [class.is-valid]="passcode?.valid && passcode?.touched" (focus)="onPasswordFocus()" />
          @if (passcode?.valid && passcode?.touched && (errorMessage !== 'Password incorrect. Please try again')) {
          <span class="success-circle"></span>
          }
          @if ((passcode?.invalid && (isPasswordTyping || passcode?.touched)) || passcode?.errors?.['backendError'] ||
          email?.errors?.['backendError']) {
          <span class="error-circle"></span>
          }
          <span class="toggle" (click)="togglePassword()">{{ showPassword ? 'Hide' : 'Show' }}</span>
        </div>
      </div>

      <div class="error_wrap" [ngClass]="{ 'show': errorMessage }">
        @if (errorMessage) {
        <div class="error_message">
          {{ errorMessage }}
        </div>
        }
      </div>
      <div class="help-links">
        <small class="back-link help_text"><a href="#/forgotpassword">Having trouble signing in? </a></small>
        <small class="back-link help_text otp-login-link"><a href="#/login-with-otp">Login with OTP</a></small>
      </div>
      <!-- <app-auth-festive-decoration page="login"></app-auth-festive-decoration> -->
      <button type="submit" [disabled]="isLoading">
        @if (!isLoading) {
        <span>Sign In</span>
        }
        @if (isLoading) {
        <app-spinner [size]="16"></app-spinner>
        }
      </button>
    </form>
    }

    @if (showAgencySelection) {
    <form class="select-agency" [formGroup]="agencyForm" (ngSubmit)="onAgencyFormSubmit($event)">
      <h2>Select Agency</h2>
      <p>Please select an agency to continue</p>

      <div class="agency_tag_wrapper">
        @for (agency of visibleAgencies(); track agency._id) {
        <a [class.selected]="agencyForm.get('agency')?.value === agency._id" (click)="selectAgency(agency._id)"
          class="agency-tag">
          {{ agency.name }}
        </a>
        }

        @if (agencies().length > 2) {
        <a class="next_btn" (click)="nextSlide()" [class.disabled]="currentIndex() >= agencies().length - 2">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
        }
        @if (agencies().length > 2) {
        <a class="prev_btn" (click)="prevSlide()" [class.disabled]="currentIndex() === 0">
          <svg width="13" height="6" viewBox="0 0 13 6" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.905273 0.758484L6.03861 4.75848L11.9053 0.758484" stroke-width="0.5" />
          </svg>
        </a>
        }
      </div>
      <div class="btn_wrap">
        <a href="#" class="back-link" (click)="backToLogin($event)">Back to Login</a>
        <button type="submit" [disabled]="isLoading">
          @if (!isLoading) {
          <span>Continue</span>
          }
          @if (isLoading) {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
  </div>

  @if (halloween && halloweenDecorReady()) {
  <div class="halloween-flying-ybats" aria-hidden="true">
    @for (bat of loginHalloweenYbats; track $index) {
    <img
      class="halloween-flying-ybat"
      [class.halloween-flying-ybat--a]="bat.path === 'a'"
      [class.halloween-flying-ybat--b]="bat.path === 'b'"
      [class.halloween-flying-ybat--c]="bat.path === 'c'"
      src="assets/images/events/halloween-ybat.gif"
      alt=""
      draggable="false"
      loading="lazy"
      decoding="async"
      [style.--bat-left]="bat.left"
      [style.--bat-top]="bat.top"
      [style.--bat-size]="bat.size"
      [style.--bat-duration]="bat.duration"
      [style.--bat-delay]="bat.delay"
    />
    }
  </div>
  <div class="halloween-hanging-skel" aria-hidden="true">
    <span class="halloween-hanging-skel__string"></span>
    <img
      src="assets/images/events/halloween-skel.gif"
      class="halloween-hanging-skel__gif"
      alt=""
      draggable="false"
      loading="lazy"
      decoding="async"
    />
  </div>
  }

  @if (remembrance) {
  <div class="remembrance-bees" aria-hidden="true">
    @for (bee of loginHoneybees; track $index) {
    <img
      class="remembrance-bee"
      [class.remembrance-bee--right]="bee.path === 'right'"
      [class.remembrance-bee--left]="bee.path === 'left'"
      src="assets/images/events/honeybee.gif"
      alt=""
      draggable="false"
      loading="lazy"
      decoding="async"
      [style.--bee-left]="bee.left"
      [style.--bee-top]="bee.top"
      [style.--bee-size]="bee.size"
      [style.--bee-duration]="bee.duration"
      [style.--bee-delay]="bee.delay"
    />
    }
  </div>
  }

  @if (!hideLoginIllustrations) {
  <div class="illustration right">
    <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
    <img src="assets/images/login/moon.png" alt="Moon Illustration" />
  </div>
  }

</div>

<footer [class.fall-of-summer]="fallOfSummer" [class.thanksgiving]="thanksgiving" [class.halloween]="halloween" [class.remembrance]="remembrance">© 2000–{{ currentYear }} Licenced Copyright by TechWyse. All rights reserved.</footer>
}